// Date 2021-09-27 20:32:25

import mintalMesPrdSmeltingMaterialBatching from "@/store/mintalMes/prd/MintalMesPrdSmeltingMaterialBatchingStore.js";
import mintalMesPrdMonthPlan from "@/store/mintalMes/prd/MintalMesPrdMonthPlanStore.js";
import mintalMesPrdShiftPlan from "@/store/mintalMes/prd/MintalMesPrdShiftPlanStore.js";
import mintalMesPrdDowntimePlan from "@/store/mintalMes/prd/MintalMesPrdDowntimePlanStore.js";
import mintalMesPrdMaterialRequirePlan from "@/store/mintalMes/prd/MintalMesPrdMaterialRequirePlanStore.js";
import mintalMesPrdProductionResult from "@/store/mintalMes/prd/MintalMesPrdProductionResultStore.js";
import mintalMesPrdProductionInfo from "@/store/mintalMes/prd/MintalMesPrdProductionInfoStore.js";
import mintalMesPrdProductionMaterialCost from "@/store/mintalMes/prd/MintalMesPrdProductionMaterialCostStore.js";
import mintalMesPrdProductionEnergyCost from "@/store/mintalMes/prd/MintalMesPrdProductionEnergyCostStore.js";
import mintalMesPrdShiftHandover from "@/store/mintalMes/prd/MintalMesPrdShiftHandoverStore.js";
import mintalMesPrdCraft from "@/store/mintalMes/prd/MintalMesPrdCraftStore.js";
import mintalMesPrdCraftConfig from "@/store/mintalMes/prd/MintalMesPrdCraftConfigStore.js";
import mintalMesPrdCraftEnergyConfig from "@/store/mintalMes/prd/MintalMesPrdCraftEnergyConfigStore.js";
import mintalMesPrdCraftMaterialConfig from "@/store/mintalMes/prd/MintalMesPrdCraftMaterialConfigStore.js";
import mintalMesPrdSmeltingPreheatingKiln from "@/store/mintalMes/prd/MintalMesPrdSmeltingPreheatingKilnStore.js";
import mintalMesPrdSmeltingFurnaceMeasure from "@/store/mintalMes/prd/MintalMesPrdSmeltingFurnaceMeasureStore.js";
import mintalMesPrdSmeltingCoolingWater from "@/store/mintalMes/prd/MintalMesPrdSmeltingCoolingWaterStore.js";
import mintalMesPrdSmeltingFurnaceLiningTemperature from "@/store/mintalMes/prd/MintalMesPrdSmeltingFurnaceLiningTemperatureStore.js";
import mintalMesPrdSmeltingElectrodePaste from "@/store/mintalMes/prd/MintalMesPrdSmeltingElectrodePasteStore.js";
import mintalMesPrdSmeltingThickenerPump from "@/store/mintalMes/prd/MintalMesPrdSmeltingThickenerPumpStore.js";
import mintalMesPrdSmeltingElectrodeDischarge from "@/store/mintalMes/prd/MintalMesPrdSmeltingElectrodeDischargeStore.js";
import mintalMesPrdSmeltingElectrodeWeightChange from "@/store/mintalMes/prd/MintalMesPrdSmeltingElectrodeWeightChangeStore.js";
import mintalMesPrdSmeltingElectrodeParameter from "@/store/mintalMes/prd/MintalMesPrdSmeltingElectrodeParameterStore.js";
import mintalMesPrdSmeltingGasCabinet from "@/store/mintalMes/prd/MintalMesPrdSmeltingGasCabinetStore.js";
import mintalMesPrdSmeltingGasFlow from "@/store/mintalMes/prd/MintalMesPrdSmeltingGasFlowStore.js";
import mintalMesPrdSmeltingSlagIron from "@/store/mintalMes/prd/MintalMesPrdSmeltingSlagIronStore.js";
import mintalMesPrdSmeltingResistanceBeforeIron from "@/store/mintalMes/prd/MintalMesPrdSmeltingResistanceBeforeIronStore.js";
import mintalMesPrdSmeltingDrillParameter from "@/store/mintalMes/prd/MintalMesPrdSmeltingDrillParameterStore.js";
import mintalMesPrdSmeltingPelletFeeding from "@/store/mintalMes/prd/MintalMesPrdSmeltingPelletFeedingStore.js";
import mintalMesPrdSmeltingSubstationRecord from "@/store/mintalMes/prd/MintalMesPrdSmeltingSubstationRecordStore.js";
import mintalMesPrdSmeltingFurnacePowerFailureRecord from "@/store/mintalMes/prd/MintalMesPrdSmeltingFurnacePowerFailureRecordStore.js";
import mintalMesPrdPelletizingCeramicFilterParameter from "@/store/mintalMes/prd/MintalMesPrdPelletizingCeramicFilterParameterStore.js";
import mintalMesPrdFurnaceBatch from "@/store/mintalMes/prd/MintalMesPrdFurnaceBatchStore.js";
import mintalMesPrdSmeltingPreheatingKilnStop from "@/store/mintalMes/prd/MintalMesPrdSmeltingPreheatingKilnStopStore.js";
import mintalMesPrdManagePlan from "@/store/mintalMes/prd/MintalMesPrdManagePlanStore.js";
import mintalMesPrdPelletizingGrindingParameter from "@/store/mintalMes/prd/MintalMesPrdPelletizingGrindingParameterStore.js";
import mintalMesPrdPelletizingFilterParameter from "@/store/mintalMes/prd/MintalMesPrdPelletizingFilterParameterStore.js";
import mintalMesPrdPelletizingBallingParameter from "@/store/mintalMes/prd/MintalMesPrdPelletizingBallingParameterStore.js";
import mintalMesPrdPelletizingRoastingParameter from "@/store/mintalMes/prd/MintalMesPrdPelletizingRoastingParameterStore.js";
import mintalMesPrdPelletizingWaterSystemParameter from "@/store/mintalMes/prd/MintalMesPrdPelletizingWaterSystemParameterStore.js";
import mintalMesPrdPelletizingProductTreatmentParameter from "@/store/mintalMes/prd/MintalMesPrdPelletizingProductTreatmentParameterStore.js";
import mintalMesPrdPelletizingIngredientPlan from "@/store/mintalMes/prd/MintalMesPrdPelletizingIngredientPlanStore.js";
import mintalMesPrdPelletizingIngredientPlanItem from "@/store/mintalMes/prd/MintalMesPrdPelletizingIngredientPlanItemStore.js";
import mintalMesPrdSmeltingElectrodeDischargePlan from "@/store/mintalMes/prd/MintalMesPrdSmeltingElectrodeDischargePlanStore.js";
import mintalMesPrdIronOutput from "@/store/mintalMes/prd/MintalMesPrdIronOutputStore.js";
import mintalMesPrdPowerStationRecord from "@/store/mintalMes/prd/MintalMesPrdPowerStationRecordStore.js";
import mintalMesPrdSubstationPowerRecord from "@/store/mintalMes/prd/MintalMesPrdSubstationPowerRecordStore.js";
import mintalMesPrdProductionEquipQuota from "@/store/mintalMes/prd/MintalMesPrdProductionEquipQuotaStore.js";
import mintalMesPrdGenertorSetDowntime from "@/store/mintalMes/prd/MintalMesPrdGenertorSetDowntimeStore.js";
import mintalMesPrdFieldOpcConfig from "@/store/mintalMes/prd/MintalMesPrdFieldOpcConfigStore.js";
import mintalMesPrdSmeltingCirculatingWater from "@/store/mintalMes/prd/MintalMesPrdSmeltingCirculatingWaterStore.js";
import mintalMesPrdSmeltingMaterialConsumption from "@/store/mintalMes/prd/MintalMesPrdSmeltingMaterialConsumptionStore.js";

const genericEntities = [
    'mintalMesPrdSmeltingMaterialBatching',
    'mintalMesPrdMonthPlan',
    'mintalMesPrdShiftPlan',
    'mintalMesPrdDowntimePlan',
    'mintalMesPrdMaterialRequirePlan',
    'mintalMesPrdProductionResult',
    'mintalMesPrdProductionInfo',
    'mintalMesPrdProductionMaterialCost',
    'mintalMesPrdProductionEnergyCost',
    'mintalMesPrdShiftHandover',
    'mintalMesPrdCraft',
    'mintalMesPrdCraftConfig',
    'mintalMesPrdCraftEnergyConfig',
    'mintalMesPrdCraftMaterialConfig',
    'mintalMesPrdSmeltingPreheatingKiln',
    'mintalMesPrdSmeltingFurnaceMeasure',
    'mintalMesPrdSmeltingCoolingWater',
    'mintalMesPrdSmeltingFurnaceLiningTemperature',
    'mintalMesPrdSmeltingElectrodePaste',
    'mintalMesPrdSmeltingThickenerPump',
    'mintalMesPrdSmeltingElectrodeDischarge',
    'mintalMesPrdSmeltingElectrodeWeightChange',
    'mintalMesPrdSmeltingElectrodeParameter',
    'mintalMesPrdSmeltingGasCabinet',
    'mintalMesPrdSmeltingGasFlow',
    'mintalMesPrdSmeltingSlagIron',
    'mintalMesPrdSmeltingResistanceBeforeIron',
    'mintalMesPrdSmeltingDrillParameter',
    'mintalMesPrdSmeltingPelletFeeding',
    'mintalMesPrdSmeltingSubstationRecord',
    'mintalMesPrdSmeltingFurnacePowerFailureRecord',
    'mintalMesPrdPelletizingCeramicFilterParameter',
    'mintalMesPrdFurnaceBatch',
    'mintalMesPrdSmeltingPreheatingKilnStop',
    'mintalMesPrdManagePlan',
    'mintalMesPrdPelletizingGrindingParameter',
    'mintalMesPrdPelletizingFilterParameter',
    'mintalMesPrdPelletizingBallingParameter',
    'mintalMesPrdPelletizingRoastingParameter',
    'mintalMesPrdPelletizingWaterSystemParameter',
    'mintalMesPrdPelletizingProductTreatmentParameter',
    'mintalMesPrdPelletizingIngredientPlan',
    'mintalMesPrdPelletizingIngredientPlanItem',
    'mintalMesPrdSmeltingElectrodeDischargePlan',
    'mintalMesPrdIronOutput',
    'mintalMesPrdPowerStationRecord',
    'mintalMesPrdSubstationPowerRecord',
    'mintalMesPrdProductionEquipQuota',
    'mintalMesPrdGenertorSetDowntime',
    'mintalMesPrdFieldOpcConfig',
    'mintalMesPrdSmeltingCirculatingWater',
    'mintalMesPrdSmeltingMaterialConsumption'
]
const entities = {
    mintalMesPrdSmeltingMaterialBatching,
    mintalMesPrdMonthPlan,
    mintalMesPrdShiftPlan,
    mintalMesPrdDowntimePlan,
    mintalMesPrdMaterialRequirePlan,
    mintalMesPrdProductionResult,
    mintalMesPrdProductionInfo,
    mintalMesPrdProductionMaterialCost,
    mintalMesPrdProductionEnergyCost,
    mintalMesPrdShiftHandover,
    mintalMesPrdCraft,
    mintalMesPrdCraftConfig,
    mintalMesPrdCraftEnergyConfig,
    mintalMesPrdCraftMaterialConfig,
    mintalMesPrdSmeltingPreheatingKiln,
    mintalMesPrdSmeltingFurnaceMeasure,
    mintalMesPrdSmeltingCoolingWater,
    mintalMesPrdSmeltingFurnaceLiningTemperature,
    mintalMesPrdSmeltingElectrodePaste,
    mintalMesPrdSmeltingThickenerPump,
    mintalMesPrdSmeltingElectrodeDischarge,
    mintalMesPrdSmeltingElectrodeWeightChange,
    mintalMesPrdSmeltingElectrodeParameter,
    mintalMesPrdSmeltingGasCabinet,
    mintalMesPrdSmeltingGasFlow,
    mintalMesPrdSmeltingSlagIron,
    mintalMesPrdSmeltingResistanceBeforeIron,
    mintalMesPrdSmeltingDrillParameter,
    mintalMesPrdSmeltingPelletFeeding,
    mintalMesPrdSmeltingSubstationRecord,
    mintalMesPrdSmeltingFurnacePowerFailureRecord,
    mintalMesPrdPelletizingCeramicFilterParameter,
    mintalMesPrdFurnaceBatch,
    mintalMesPrdSmeltingPreheatingKilnStop,
    mintalMesPrdManagePlan,
    mintalMesPrdPelletizingGrindingParameter,
    mintalMesPrdPelletizingFilterParameter,
    mintalMesPrdPelletizingBallingParameter,
    mintalMesPrdPelletizingRoastingParameter,
    mintalMesPrdPelletizingWaterSystemParameter,
    mintalMesPrdPelletizingProductTreatmentParameter,
    mintalMesPrdPelletizingIngredientPlan,
    mintalMesPrdPelletizingIngredientPlanItem,
    mintalMesPrdSmeltingElectrodeDischargePlan,
    mintalMesPrdIronOutput,
    mintalMesPrdPowerStationRecord,
    mintalMesPrdSubstationPowerRecord,
    mintalMesPrdProductionEquipQuota,
    mintalMesPrdGenertorSetDowntime,
    mintalMesPrdFieldOpcConfig,
    mintalMesPrdSmeltingCirculatingWater,
    mintalMesPrdSmeltingMaterialConsumption
}

export {genericEntities}

export default entities